import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import tchHeaderLogo from "../assets/tch-header-logo.png";

const LandingPage = () => {
  const navigate = useNavigate();

  const [fadeIn, setFadeIn] = useState(false);

  // Carousel State
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [slideDirection, setSlideDirection] = useState("next"); 
  const [isSliding, setIsSliding] = useState(false);

  const carouselSlides = [
    {
      title: "Your Comfort Awaits",
      text: "Book your perfect room at Tender Castle Hostel",
    },
    {
      title: "Modern • Peaceful • Secure",
      text: "Experience student living the way it should be",
    },
    {
      title: "Spacious Self-Contained Rooms",
      text: "Designed for comfort, privacy, and convenience",
    },
  ];

  // HERO FADE-IN
  useEffect(() => {
    const timer = setTimeout(() => setFadeIn(true), 100);
    return () => clearTimeout(timer);
  }, []);

  // AUTO-SLIDE (Left→Right animation)
  useEffect(() => {
    const interval = setInterval(() => {
      triggerSlide("next");
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const triggerSlide = (direction) => {
    if (isSliding) return;

    setSlideDirection(direction);
    setIsSliding(true);

    setTimeout(() => {
      setCarouselIndex((prev) =>
        direction === "next"
          ? (prev + 1) % carouselSlides.length
          : prev === 0
          ? carouselSlides.length - 1
          : prev - 1
      );
      setIsSliding(false);
    }, 450); // match CSS transition
  };

  return (
    <div className="min-h-screen bg-[#FFF7E6] flex flex-col">
      {/* HEADER */}
      <header className="w-full bg-[#b4642d] shadow-sm py-4">
        <div className="max-w-5xl mx-auto px-6 flex items-center justify-start">
          <img
            src={tchHeaderLogo}
            alt="Tender Castle Hostel Logo"
            className="h-14 md:h-16 w-auto"
          />
        </div>
      </header>

      {/* MAIN SECTION */}
      <main className="flex-1">
        {/* HERO SECTION */}
        <section
          className={`text-center pt-10 pb-4 px-6 max-w-4xl mx-auto transition-all duration-1000 ${
            fadeIn ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-600 mb-4">
            Where Comfort Living is Perfected
          </h1>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
            Discover a serene, secure, and modern hostel designed to provide the
            ultimate comfort for students. Enjoy furnished and spacious rooms,
            reliable utilities, and a peaceful environment — all at Tender
            Castle Hostel.
          </p>

          <button
            onClick={() => navigate("/booking")}
            className="mt-12 mb-9 bg-[#b4642d] hover:bg-[#8c4f1f] text-white px-8 py-3 rounded-lg text-lg shadow-md transition"
          >
            Book a Room
          </button>
        </section>

        {/* FEATURE CARDS */}
        <section className="max-w-5xl mx-auto grid md:grid-cols-3 gap-6 px-6 pb-10 pt-4">
          {[
            {
              title: "Studio Style Rooms",
              text: "Self-contained spacious rooms with wardrobes, kitchen cabinets, and shower bath.",
            },
            {
              title: "Reliable Utility Services",
              text: "Water, sanitation, garbage collection, NEPA & generator powerhouse.",
            },
            {
              title: "Safe & Secure",
              text: "Strong security and monitored access for peace of mind.",
            },
          ].map((card, index) => (
            <div
              key={index}
              className={`bg-white shadow rounded-xl p-6 text-center transition-all duration-1000 delay-${
                (index + 1) * 200
              } ${fadeIn ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
            >
              <h3 className="text-xl font-semibold text-[#b4642d] mb-2">
                {card.title}
              </h3>
              <p className="text-gray-600">{card.text}</p>
            </div>
          ))}
        </section>

        {/* ⭐⭐⭐ RESTORED CAROUSEL — NOW LEFT-TO-RIGHT SLIDING ⭐⭐⭐ */}
        <section className="mt-6 mb-16 text-center px-6 max-w-3xl mx-auto">
          <div className="relative bg-white rounded-xl shadow-lg overflow-hidden p-10">

            {/* SLIDER CONTAINER */}
            <div
              className={`transform transition-transform duration-500 ${
                isSliding
                  ? slideDirection === "next"
                    ? "-translate-x-full"
                    : "translate-x-full"
                  : "translate-x-0"
              }`}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-[#b4642d]">
                {carouselSlides[carouselIndex].title}
              </h2>

              <p className="text-gray-700 text-lg mt-3">
                {carouselSlides[carouselIndex].text}
              </p>
            </div>

            <button
              onClick={() => navigate("/booking")}
              className="mt-8 bg-[#b4642d] hover:bg-[#8c4f1f] text-white px-7 py-3 rounded-lg shadow-md transition"
            >
              Book Now
            </button>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="bg-[#b4642d] text-center text-white py-4">
        © {new Date().getFullYear()} Tender Castle Hostel — Comfort Living Perfected
      </footer>

      {/* FLOATING BUTTON */}
      <button
        onClick={() => navigate("/booking")}
        className="fixed bottom-6 right-6 bg-[#b4642d] text-white px-5 py-3 rounded-full shadow-lg text-base animate-bounce hover:scale-110 transition"
      >
        Book Now
      </button>
    </div>
  );
};

export default LandingPage;
